import { render, staticRenderFns } from "./DefectDetails.vue?vue&type=template&id=11d17f10&scoped=true&"
import script from "./DefectDetails.vue?vue&type=script&lang=js&"
export * from "./DefectDetails.vue?vue&type=script&lang=js&"
import style0 from "./DefectDetails.vue?vue&type=style&index=0&id=11d17f10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d17f10",
  null
  
)

export default component.exports